var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorLayout',[_c('p',[_vm._v("こちらのべネアカウントでご利用可能なサービスはログイン画面が異なります。")]),_c('p',[_vm._v("ご入力いただいたべネアカウントにて、再度下記専用ログイン画面よりログインください。")]),_c('p',[_vm._v(" 専用ログイン画面： "),_c('a',{attrs:{"href":_vm.loginUrl}},[_vm._v(_vm._s(_vm.loginUrl))])]),_c('p',[_vm._v("※ベネフィット・ステーション公式アプリはご利用いただけません。ブラウザでご利用ください。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }